import { Modal } from "antd";
import React from "react";
import InputField from "../../../../../reusable-components/TNInputField";
import { InputfieldTypes } from "../../../../../enums/InputFieldAttributesEnums";
import { CommonButtonTexts } from "../../../../../enums/ButtonAttributesEnums";
import { AddNewMaterialModalConsts } from "./constants";
import { useFormContext } from "react-hook-form";
import QuarryDatabaseService from "../../../../../services/quarryDatabase.service";
import TNLoader from "../../../../../reusable-components/TNLoader";
import { FormFieldNames } from "../constants";
import { QueryKeys } from "../../../../../constants/QueryKeys";
import { useQueryClient } from "@tanstack/react-query";

interface AddNewMaterialModalProps {
  isOpen: boolean;
  handleClose: () => void;
  subCategoriesList: [];
}

const AddNewMaterialModal = ({
  isOpen,
  handleClose,
  subCategoriesList,
}: AddNewMaterialModalProps) => {
  const { getValues, handleSubmit, resetField, setError, clearErrors } = useFormContext();
  const { TITLE, LABEL, NAME, PLACEHOLDER } = AddNewMaterialModalConsts;
  const queryClient = useQueryClient();getValues(FormFieldNames?.SUB_CATEGORY)
  const { AddNewMaterialName } = QuarryDatabaseService();
  const { mutateAsync: addMaterial, isPending } = AddNewMaterialName(getValues(FormFieldNames?.SUB_CATEGORY));

  const handleAddNewMaterialName = async () => {
    if(!!!getValues(FormFieldNames.NEW_MATERIAL)) {
      setError(FormFieldNames.NEW_MATERIAL, { message:"Material name is requried" });
      return;
    }
    const filteredValues = subCategoriesList?.filter(
      (item) => item?.subCategory === getValues(FormFieldNames?.SUB_CATEGORY),
    );
    const payload = {
      ...filteredValues?.[0],
      materialValue: getValues(FormFieldNames?.NEW_MATERIAL),
      subCategory: getValues(FormFieldNames?.SUB_CATEGORY),
      category: getValues(FormFieldNames?.CATEGORY),
    };
    delete payload?.label;
    await addMaterial(payload);
    clearErrors();
    resetField(FormFieldNames?.NEW_MATERIAL);
    handleClose();
  };

  return (
    <>
      <TNLoader isLoading={isPending} />
      <Modal
        title={TITLE}
        visible={isOpen}
        okText={CommonButtonTexts.SUBMIT}
        onOk={handleAddNewMaterialName}
        onCancel={() => {
          clearErrors();
          resetField(FormFieldNames.NEW_MATERIAL);
          handleClose();
        }}
        destroyOnClose
      >
        <InputField
          type={InputfieldTypes.TEXT}
          label={LABEL}
          name={NAME}
          placeholder={PLACEHOLDER}
        />
      </Modal>
    </>
  );
};

export default AddNewMaterialModal;
